import { useLanguage } from "contexts/LocalizationContext/hooks";
import { getPageUrl } from "utils/getPageUrl";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import {
  ChakraBox as Box,
  ChakraLink as Link,
  ChakraFlex as Flex,
  ChakraText as Text,
} from "@airhelp/react-ui-components";
import type { TopBannerProps } from "./TopBanner.d";

const TOP_BANNER_CHECK_COMPENSATION_UA = ["clicked", "TopBanner", "CheckYourCompensation"] as const;
const TOP_BANNER_CHECK_COMPENSATION = { event: "check_compensation", label: "check_your_compensation", placement: "top_banner" } as const;

export const TopBanner = ({ bannerText, buttonText }: TopBannerProps) => {
  const language = useLanguage();
  const handletrackEvents = () => {
    trackUAEvent(TOP_BANNER_CHECK_COMPENSATION_UA);
    trackCustomEvent(TOP_BANNER_CHECK_COMPENSATION);
  };

  return (
    <Box bg="primary.500" color="white" py={2} px={2} width="100%" boxShadow="10px -8px 24px rgba(123, 150, 176, 0.2)">
      <Flex
        mx="auto"
        justifyContent="center"
        alignItems="center"
        maxWidth={MAX_GRID_WIDTH}
        lineHeight={5}
        flexDirection={{ base: "column", lg: "row" }}
      >
        <Text
          display="block"
          textAlign="center"
          fontSize="s"
          fontWeight="bold"
          data-testid="top-airline-strike-bar"
          whiteSpace="pre-wrap"
        >
          {bannerText}
        </Text>
        <Link
          display="inline"
          color="white"
          _hover={{ color: "primary.200" }}
          fontWeight="bold"
          href={getPageUrl(language, "webappNewClaim")}
          textDecoration="underline"
          onClick={handletrackEvents}
          title={buttonText}
          ml={2}
        >
          {buttonText}
        </Link>
      </Flex>
    </Box>
  );
};
